import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Radio, Checkbox, Table } from 'antd';
import { module_tabs, group_columns } from './statics';
import { editGroupModulePermissionsRequest } from '../redux/actions/edit_group_module_permissions.actions';
import { setAllFieldsPermissionsRequest } from '../redux/actions/get_modules_structure.actions';
import {
    checkStatuses, checkStatus, firstLetterUpperCase, isExist,
} from '../../../../shared/helpers';
import GroupModels from './GroupModels';

const mapStateToProps = (state) => {
    const {
        moduleOptionFields, filteredModule, moduleOption, loading, group_id,
    } = state.UserManagement.User_group_update;
    return {
        moduleOptionFields, filteredModule, moduleOption, loading, group_id,
    };
}; const
    { Column } = Table;

export default connect(mapStateToProps, null)(class GroupModulesOptions extends Component {
  handleChangeGroupOptions = event => this.props.dispatch({ type: 'SET_MODULE_OPTION', payload: event.target.value });

  handleChangeGroupOptionsPermissions = event => this.props.dispatch(editGroupModulePermissionsRequest(event.target));

  setAllFieldsPermissionsRequest = event => this.props.dispatch(setAllFieldsPermissionsRequest(event.target));

  render() {
      const { filteredModule, moduleOptionFields, moduleOption } = this.props;
      const components = {
          body: {
              wrapper: () => (
                  <tbody>
                      {moduleOptionFields && Object.keys(moduleOptionFields).map(option => (
                          <tr key={moduleOptionFields[option].URL} className="user_profile_email_table_row">
                              <td className="user-group-border-cell">
                                  {moduleOptionFields[option].displayName || moduleOptionFields[option].modelName}
                              </td>
                              <td className="user-group-border-cell-action">
                                  <Checkbox
                                      url={moduleOptionFields[option].URL}
                                      onChange={this.handleChangeGroupOptionsPermissions}
                                      checked={checkStatus(moduleOptionFields[option])}
                                  />
                              </td>
                          </tr>
                      ))}
                  </tbody>
              ),
          },
      };

      return (
          <Fragment>
              <Radio.Group buttonStyle="solid" style={{ margin: ' 0 0 15px 0' }}>
                  {module_tabs.map((tab, index) => (
                      <Radio.Button
                          key={index}
                          value={tab.name}
                          onChange={this.handleChangeGroupOptions}
                      >
                          {tab.value}
                      </Radio.Button>
                  ))}
              </Radio.Group>
              <Fragment>
                  {isExist(moduleOptionFields)
                      ? (
                          <Fragment>
                              <span className="left_right_position_for_checkbox">{`Set Fields For ${firstLetterUpperCase(moduleOption)}:`}</span>
                              {/* {moduleOption === 'models' && */}
                              {/* crud_options.map((option, index) => ( */}


                              {/* <Fragment key={index}> */}
                              {/* <Checkbox */}
                              {/* status={option.title} */}
                              {/* id={moduleOption} */}
                              {/* url={filteredModule.URL} */}
                              {/* // checked={checkStatuses(moduleOptionFields, moduleOption)} */}
                              {/* onChange={this.setAllFieldsPermissionsRequest} /> */}
                              {/* <span className='right_position_for_checkbox'>{option.title}</span> */}
                              {/* </Fragment>))} */}


                              <Checkbox
                                  id={moduleOption}
                                  url={filteredModule.URL}
                                  checked={checkStatuses(moduleOptionFields, moduleOption)}
                                  onChange={this.setAllFieldsPermissionsRequest}
                              />
                              <span className="right_position_for_checkbox">All</span>
                          </Fragment>
                      ) : null}
                  {!isExist(moduleOptionFields)
                      ? <div style={{ paddingLeft: '8%', fontStyle: 'italic' }}>No Data</div>
                      : moduleOption === 'models' ? <GroupModels />
                          : (
                              <Table
                                  rowKey="URL"
                                  bordered
                                  style={{ width: '50%' }}
                                  pagination={false}
                                  size="small"
                                  components={components}
                              >
                                  {group_columns.map(item => <Column align="center" title={item.title} dataIndex={item.dataIndex} key={item._id} />)}
                              </Table>
                          )}
              </Fragment>
          </Fragment>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/components/GroupModulesOptions.js